import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Typography, TextField } from '@mui/material';
import firebase from 'firebase';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from "@mui/styles/";
const useStyles = makeStyles({
  container: {
    flex: 1,
    display: "flex",

  },
  descriptionHeader: {
    padding: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#dfe4fe",
  },
  storeText: {
   
    fontWeight: "bold",
    marginLeft: 10,
    fontSize: 16,
  },
  details: {
    marginVertical: 0,
  },
  itemContainer: {
    direction: "ltr",
    marginTop: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    flex: 1,
    resizeMode: 'contain',
  },
  phoneText: { textAlign: "center", color: "gray", fontWeight: "400", fontSize: 15 },
});
const StoreScreen = ({}) => {
  const [store, setStore] = React.useState(undefined);
  const [loading, setLoading] = React.useState(false);
  const { t, i18n } = useTranslation();
  const params = useParams();
  const width  = window.innerWidth;
  const imageW = width * 0.8;
  const imageH = imageW;
  const styles = useStyles();
  const customTheme = useTheme();
  const loadStoreData = async () => {
    setLoading(true);
    if (!!params?.id) {
      const storeData = await (await firebase.firestore().collection('stores').doc(params?.id).get()).data();
      setStore(storeData);
       setLoading(false);
    }
  }
  const translateTitle = (title) => {
    if(i18n.language === 'ar'){
    switch (title) {
      case 'SATURDAY':
        return "السبت"
        break;
      case 'SUNDAY':
        return "الاحد"
        break;
      case 'MONDAY':
        return "الاثنين"
        break;
        case 'TUESDAY':
          return "الثلاثاء"
          break;
      case 'WEDENSDAY' || "WEDNESDAY":
        return "الاربعاء"
        break;
        case 'THURSDAY':
          return "الخميس"
          break;
      case 'FRIDAY':
        return "الجمعة"
        break;
      default:
        return "";
        break;
    }}else{
      return title;
    }
  }
  const RenderWorkingDay = ({ day, title }) => {
    return (
      <div style={{ padding: 10, display: "flex", justifyContent: "space-between", flexDirection: "row", borderWidth: 0.5, borderColor: '#fac904' , borderStyle:"solid"}}>
        <Typography style={{ textAlign:"center",display: "flex", flexDirection: "column", alignItems: "baseline", textAlign: "center", width:40 }}>
          {translateTitle(title)}
        </Typography>
        {!!day?.checked ? <>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", textAlign: "center" }}>
            <div style={{ display: "flex", flexDirection: "row",alignContent:"center" }}>
              <Typography style={{ color: "green",textAlign:"flex-start" }}>
                {t('stores.openAt')}
              </Typography>
              <Typography style={{ color: customTheme.light.dark,textAlign:"flex-start" }}>
                {day?.opensAt ?? ""}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "baseline", textAlign: "center" }}>
            <div style={{ display: "flex", flexDirection: "row", alignContent:"center"}}>
              <Typography style={{ color: "red", textAlign:"center" }}>
                {t('stores.closeAt')}
              </Typography>
              <Typography style={{ color: customTheme.light.dark,textAlign:"center"  }}>
                {day?.closeAt ?? ""}
              </Typography>
            </div>
          </div>
        </> :
          <Typography style={{ color: "red", display: "flex" ,textAlign:"center",flexDirection: "column", alignItems: "baseline", textAlign: "center" }}>
            {t('stores.closed')}
          </Typography>
        }
      </div>
    );
  }

  React.useEffect(() => {
    if (params?.id) {
      loadStoreData();
    }
  }, [params]);

  return (
  
  
      
        !loading ? <div style={{padding:20}}>
          {!!store &&
            <div className={styles.itemContainer} style={ {
              width: "100%",
              display: "flex",
              flexDirection:"row",
              justifyContent:"center"
            }}>
               {!!store.image && <div style={{flexDirection:"column" , width:"50%"}}>
              <img
              className={styles.image}
                style={{
                  width: 600,
                  height: 400,
                }}
                src={store.image && store.image != '' ? store.image : require("../../assets/placeholder-image.png")}
              />
</div>}
              <div style={{flexDirection:"column", width:"50%" ,justifyContent:'space-between'}}>
             
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginHorizontal: 10,  }} >
              <Typography style={{marginBlock:0, color: customTheme.light.dark,marginLeft:10 , fontSize:22}} className={styles.storeText}>{store[i18n.language == "ar" ? "nameAr" : "nameEn"]}</Typography>
            </div>
          
            { !!store.phone &&
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginHorizontal: 10, marginTop: 6 }} >
                <Typography className={styles.phoneText} style={{fontSize:22}}>{store.phone} </Typography>
              </div>}
            
              <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: 16, marginHorizontal: 10 }} >
                <Typography style={{marginBlock:0, color: customTheme.light.dark,fontSize:22}} className={styles.storeText}>{`${store.emarite + ", " ?? ""} ${store.zone + "," ?? ""} ${store.branch ?? ""}`}</Typography>
              </div>
        
          </div>
        
            </div>}
         
    
           <div style={{ padding: 10,marginTop:16, display: "flex", justifyContent: "space-between", flexDirection: "row", borderWidth: 0.5, borderColor: '#fac904' , borderStyle:"solid"}}>
        <Typography style={{ textAlign:"center",display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", fontSize:18, fontWeight:"bold" }}>
          {"Day"}
        </Typography>
         <>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <div style={{ display: "flex", flexDirection: "row",alignContent:"center" }}>
              <Typography style={{ textAlign:"center", fontSize:18, fontWeight:"bold" }}>
                {"Opening Time"}
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
            <div style={{ display: "flex", flexDirection: "row", alignContent:"center"}}>
              <Typography style={{  textAlign:"center" , fontSize:18, fontWeight:"bold"}}>
              {"Closing Time"}
              </Typography>
            </div>
          </div>
        </>
          </div>
          {store && !!store.workingDays && !store.is247 &&
            <div style={{ backgroundColor: "#fff",  }}>
              {Object.keys(store.workingDays)?.length > 0 &&
                Object.keys(store.workingDays)?.map((day, index) => <RenderWorkingDay key={"day" + index} title={day.toLocaleUpperCase()} day={store.workingDays[day]} />)
              }
            </div>}
          {store && !!store.is247 &&
            <div style={{ backgroundColor: "#fff", marginTop: 16, paddingBlock: 15 }}>
              <Typography style={{ color: customTheme.light.dark, fontWeight: "bold", display: "flex", flexDirection: "column", alignItems: "baseline", textAlign: "center" }}>
                {t('stores.open247')}
              </Typography>
            </div>}
        </div>:<></>
 

  );
}


export default StoreScreen;